import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
   *{
       margin: 0;
       padding: 0;
       outline:0;
       box-sizing:border-box;
       font-family: 'Gibson', sans-serif; 
   }

   body {
    font-family: Gibson, sans-serif;
    line-height: 1.4;
    -webkit-font-smoothing: antialiased;
    max-width: 800px;
    margin: 0 auto;
    background-color: rgba(0,0,0,.04);
    font-size: 16px;

    overflow-x: hidden;
    
    @media screen and (max-width: 768px) {
        padding-top: 260px;
        padding-left: 12px;
        padding-right: 12px;
        padding-bottom: 40px;
        font-size: 15px;
    }
    
    @media screen and (max-width: 480px) {
        padding-top: 200px;
        padding-left: 10px;
        padding-right: 10px;
        padding-bottom: 30px;
        font-size: 14px;
    }
   }

   @font-face {
    font-family: 'Gibson';
    src: url('../assets/fonts/Gibson-Medium.otf') format('opentype'),
         url('../assets/fonts/Gibson-Medium.woff') format('woff');
    font-weight: 500;
    font-style: normal;
    font-display: swap;
   }

   @font-face {
    font-family: "Gibson";
    src: url("../assets/fonts/Gibson-Regular.otf") format("opentype");
    font-weight: normal;
    font-style: normal;
    font-display: swap;
   }
   
   @font-face {
    font-family: "Gibson";
    src: url("../assets/fonts/Gibson-Light.otf") format("opentype");
    font-weight: 300;
    font-style: normal;
    font-display: swap;
   }
   
   @font-face {
    font-family: "Gibson";
    src: url("../assets/fonts/Gibson-SemiBold.otf") format("opentype");
    font-weight: 600;
    font-style: normal;
    font-display: swap;
   }
   
   @font-face {
    font-family: "Gibson";
    src: url("../assets/fonts/Gibson-Bold.otf") format("opentype");
    font-weight: bold;
    font-style: normal;
    font-display: swap;
   }

   html {
    scroll-behavior: smooth;
   }
   
   img {
    max-width: 100%;
    height: auto;
   }
   
   button, input, textarea, select {
    font-family: inherit;
   }
   
   *:focus-visible {
    outline: 2px solid #ed1e79;
    outline-offset: 2px;
   }

`;

export default GlobalStyle;
